import { Link } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core/styles';
import { useLocation } from 'react-router-dom';
import { useNotificationsApi } from '@backstage/plugin-notifications';
import { BellIcon } from '../../components/icons';

const useStyles = makeStyles({
  root: {
    position: 'relative',
    display: 'inline-flex',
    lineHeight: 0,
  },
  icon: {
    width: 16,
    height: 16,
    opacity: 0.5,
    display: 'block',
  },
  // Unread dot: yellow as punctuation, ringed in white to lift off the icon.
  dot: {
    position: 'absolute',
    top: -2,
    right: -2,
    width: 7,
    height: 7,
    borderRadius: '50%',
    background: 'var(--helix-colors-brand-500)',
    boxShadow: '0 0 0 1.5px var(--bui-white)',
  },
});

/*
 * Header bell — opens the notifications page and carries the unread dot.
 *
 * The count is re-read on every navigation rather than on a timer or a signals
 * subscription: the bell is a hint, and the page it links to holds the live
 * list. A failed status call leaves the dot off rather than surfacing an error
 * in the breadcrumb bar.
 */
export function HeaderNotificationsLink() {
  const classes = useStyles();
  const { pathname } = useLocation();
  const { value, error } = useNotificationsApi(
    api => api.getStatus(),
    [pathname],
  );
  const unread = !error && (value?.unread ?? 0) > 0;

  return (
    <Link
      to="/notifications"
      underline="none"
      title="Notifications"
      aria-label="Notifications"
      className={classes.root}
    >
      <BellIcon className={classes.icon} />
      {unread && <span className={classes.dot} />}
    </Link>
  );
}
